var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,9 L22,12.2494154 C22,15.5631239 19.3137085,18.2494154 16,18.2494154 L4.65007059,18.2494154 L2,21 L2,9 C2,5.6862915 4.6862915,3 8,3 L16,3 C19.3137085,3 22,5.6862915 22,9 Z M13,10 L11,10 L11,15 L13,15 L13,10 Z M13,6 L11,6 L11,8 L13,8 L13,6 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.12b248a2d04b8f22685ed2da87e921c3.svg";
export { ForwardRef as ReactComponent };